// Lib
import React from 'react';
import { Button } from '@mui/material';
import Box from '@mui/material/Box';

// Components
import SideMenu from '../../../SideMenu';
import { ReactComponent as GileadLogo } from '../../../../assets/svg/gileadLogo.svg';
import kiteLogo from '../../../../assets/img/kiteLogo.png';
import HeaderLinks from '../HeaderLinks';

// Utils
import { getCurrentYear } from '../../../../utils/date';

const HeaderSideMenu = ({
  active,
  toggleSideMenu,
  isKiteUser,
  classes,
  cx,
  HEADER_LINKS,
  isDesktopMode,
  isTabletMode,
  onCloseSideMenu,
  pathname,
  totalCountInCart,
  onLogout,
}) => (
  <SideMenu active={active} toggleSideMenu={toggleSideMenu}>
    <Box
      height="100%"
      display="flex"
      flexDirection="column"
      justifyContent="space-between">
      <div>
        {isKiteUser ? (
          <img
            alt="logo"
            width={121}
            height={36}
            src={kiteLogo}
            data-testid="kite-logo"
          />
        ) : (
          <GileadLogo />
        )}
        <HeaderLinks
          HEADER_LINKS={HEADER_LINKS}
          classes={classes}
          cx={cx}
          isDesktopMode={isDesktopMode}
          isTabletMode={isTabletMode}
          onCloseSideMenu={onCloseSideMenu}
          pathname={pathname}
          totalCountInCart={totalCountInCart}
        />
      </div>
      <Box>
        <Button
          id="logout-btn"
          onClick={onLogout}
          className={classes.logoutButton}>
          Log Out
        </Button>
        <div className={classes.rights}>
          <div>{`${getCurrentYear()} Gilead Sciences, Inc. `}</div>
          <div>All Rights Reserved.</div>
        </div>
      </Box>
    </Box>
  </SideMenu>
);

export default HeaderSideMenu;
